import { Button, Image, Input, Link } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import logo from "../../Images/logo.svg";

import {
  getDataWithFilterUrl,
  sendResetPasswordEmail,
} from "../../controllers/APIController";
import { encryptedText } from "../../utils/helper";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loader/Loading";

const ResetPassword = ({ darkMode }) => {
  const [emailText, setEmailText] = useState("");
  const [allEmail, setAllEmail] = useState([]);
  const [validationError, setValidationError] = useState("");

  const [Loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const validateEmail = () => {
    let isValid = true;
    let errorMessage = "";
    const EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!EmailRegex.test(emailText)) {
      isValid = false;
      errorMessage = "Please enter a valid email address.";
    } else if (!allEmail.includes(emailText.toLowerCase())) {
      isValid = false;
      errorMessage = "Email does not exist, Go to register.";
    }
    setValidationError(errorMessage);
    return isValid;
  };

  const SubmitHandler = async () => {
    if (!validateEmail()) {
      return;
    }
    setLoader(true);
    const encryptedEmail = encryptedText(emailText);

    const limit = Date.now() + 5 * 60 * 1000; // add 5 minutes time to expire the link

    const url = `${process.env.REACT_APP_IP_ADDRESS}/auth/new-password?email=${encryptedEmail}&limit=${limit}`;
    const res = await sendResetPasswordEmail({ to: emailText, url });

    toast.success(
      "Email sent successfully, Check your email to reset the password!"
    );
    setLoader(false);
    setTimeout(() => {
      navigate(`/sign-in`);
    }, 300);
  };

  useEffect(() => {
    getDataWithFilterUrl("users")
      .then((data) => {
        setAllEmail(data?.map((item) => item.email));
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <Toaster position="bottom-right" reverseOrder={true} />
      {Loader ? (
        <div
          className={`absolute z-[100]  inset-0 h-screen w-screen  bg-slate-50'`}
        >
          <Loading />
        </div>
      ) : (
        ""
      )}
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 text-sm">
        <div className="w-full max-w-sm">
          {/* Form Container */}
          <div className="bg-white rounded-lg border border-gray-200 p-8">
            {/* Logo and Header */}
            <div className="text-center mb-8">
              <div className="flex justify-center mb-6">
                <Image width={48} alt="Audyt Logo" src={logo} />
              </div>
              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                Reset your password
              </h1>
              <p className="text-gray-600 text-sm">
                Enter your email to receive reset instructions
              </p>
            </div>

            {/* Error Message */}
            {validationError && (
              <div className="mb-6 p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-700 text-sm">
                  {validationError}
                </p>
              </div>
            )}

            {/* Form */}
            <form className="space-y-6 mb-6">
              <div>
                <Input
                  radius="md"
                  variant="bordered"
                  type="email"
                  label="Email"
                  placeholder="Enter your email"
                  value={emailText}
                  onChange={(e) => setEmailText(e.target.value)}
                  labelPlacement="outside"
                  classNames={{
                    label: "text-gray-700 font-medium text-sm",
                    input: "text-gray-900 text-sm",
                    inputWrapper: "bg-white border-gray-300 hover:border-emerald-400 focus-within:border-emerald-500 transition-all duration-200 h-10",
                  }}
                />
              </div>

              <Button
                id="CreateAccount"
                radius="md"
                onClick={SubmitHandler}
                className="w-full h-10 bg-emerald-600 text-white font-semibold hover:bg-emerald-700 transition-all duration-200 text-sm"
                size="sm"
              >
                Send reset instructions
                <lord-icon
                  src="https://cdn.lordicon.com/vduvxizq.json"
                  trigger="hover"
                  target="#CreateAccount"
                  
                  style={{
                    width: "16px",
                    height: "16px",
                  }}
                />
              </Button>
            </form>

            {/* Back to Sign In */}
            <div className="text-center mb-6">
              <span className="text-gray-600 text-sm">
                Remember your password?{" "}
                <button
                  onClick={() => navigate("/sign-in")}
                  className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors"
                >
                  Sign in here
                </button>
              </span>
            </div>

            {/* Terms */}
            <div className="pt-4 border-t border-gray-100">
              <p className="text-xs text-gray-500 text-center leading-relaxed">
                By resetting your password, you agree to our{" "}
                <Link href="#" size="sm" className="text-emerald-600 hover:text-emerald-700">
                  Terms of Service
                </Link>{" "}
                and{" "}
                <Link href="#" size="sm" className="text-emerald-600 hover:text-emerald-700">
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
